module.exports = __webpack_public_path__ + "img/36.7d65e6fb.png";